export default __webpack_public_path__ + "asset/img/icon-play~f7e42eb1.png";